import { render, staticRenderFns } from "./statusChangeRecord.vue?vue&type=template&id=1878812b"
import script from "./statusChangeRecord.vue?vue&type=script&lang=js"
export * from "./statusChangeRecord.vue?vue&type=script&lang=js"
import style0 from "./statusChangeRecord.vue?vue&type=style&index=0&id=1878812b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports